import { Button, Stack } from "@hiver/hiver-ui-kit";

const FilterPanelFooter = ({ onCancel, onApply }) => {
  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{ mt: 4, justifyContent: "flex-end" }}
    >
      <Button variant="text" color="tertiary" size="medium" onClick={onCancel}>
        Cancel
      </Button>
      <Button color="tertiary" size="medium" onClick={onApply}>
        Apply
      </Button>
    </Stack>
  );
};

export default FilterPanelFooter;
